import React from "react";
import PosSettingContainer from "../../components/pos/setting/PosSettingContainer";

const PosSetting = () => {
  return <PosSettingContainer />;
};

export default PosSetting;
